import { app } from '../../../../../../../../bootstrap/core';

import { receivingBankToDoComponent } from './receivingBankToDo.component';

app.component(receivingBankToDoComponent.name, receivingBankToDoComponent);
